import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getValue, getValues, getSelectionValue } from 'utils/utilityHelper'
import { getComponentName } from 'utils/acousticMappings'
import 'components/kanso/i18n/config'
import { useTranslation } from 'react-i18next'
import { setModalOpen } from 'components/kanso/ducks/modalSlice'
import Modal from "./Modal"
import ModalContent from "./ModalContent"
import ModalFooter from "components/kanso/components/modal/ModalFooter"
import ConfirmationDialog from "components/kanso/patterns/confirmationDialog/ConfirmationDialog"
import Button from 'components/kanso/atoms/button/Button'
import ButtonAcousticData from 'components/kanso/atoms/button/ButtonAcousticData'
import EditorialAcousticData from "components/kanso/patterns/editorial/EditorialAcousticData"
import FeedbackFormAcousticData from "components/kanso/patterns/feedbackForm/FeedbackFormAcousticData"

const ModalAcousticData = (props) => {
  const { 
    data,
    type
  } = props

  const modalData = data?.value?.elements
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const showModal = useSelector((state) => state?.modal?.open)

  const toggleModal = (e) => {
    e?.preventDefault && e.preventDefault()
    dispatch(setModalOpen(!showModal))
  }
  
  const openWindow = (e) => {
    e?.preventDefault && e.preventDefault()
    dispatch(setModalOpen(!showModal))
    if (typeof window !== 'undefined') {
      window.open(getValue(data.link), '_blank')
    }
  }
  
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.keyCode === 27 || e.key === 'Escape') 
      dispatch(setModalOpen(false))
    }
    window.addEventListener('keydown', handleEsc)
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [])


  return type === 'modal' ? (
    <Modal 
      show={showModal} 
      title={getValue(modalData?.title)}
      titleTag={getSelectionValue(modalData?.titleTag)}
      align={getSelectionValue(modalData?.align)}
      cssClass={getValue(modalData?.cssClass)}
      onClose={(value) => {
        toggleModal(value)
      }}
    >
      <ModalContent>
        {getValues(modalData?.content).map((content, index) => {
          if(getComponentName(content.type) === 'Editorial') {
            return <EditorialAcousticData key={`${content.type}${index}`} data={content?.elements} />
          }
          if(getComponentName(content.type) === 'FeedbackForm') {
            return <FeedbackFormAcousticData key={`${content.type}${index}`} data={content?.elements} />
          }
        })}
      </ModalContent>      
      {(getValues(modalData?.footerLinks)) && (
        <ModalFooter>
          {getValues(modalData?.footerLinks).map((button, i) => {
            return (
              <ButtonAcousticData key={i} data={button?.elements} />
            )
          })}
        </ModalFooter>
      )}      
    </Modal>
  ) : (
    <ConfirmationDialog>
      <Modal 
        show={showModal} 
        title={t('warning')}
        titleTag="h3"
        align="center"
        onClose={(value) => {
          toggleModal(value)
        }}
      >
        <ModalContent>
          <p>{getValue(data.text)}</p>
        </ModalContent>
        <ModalFooter>
          <Button type="primary" text={t('confirm')} onClick={openWindow} />
          <Button type="secondary" text={t('cancel')} onClick={toggleModal} />
        </ModalFooter>
      </Modal>
    </ConfirmationDialog>
  )
}

export default ModalAcousticData